export default "__VITE_ASSET__BN69oIXl__"